window.$ = require('jquery');
window.jQuery = window.$;

import Macy from 'macy';

$(function () {
	if ( $('#masonry').length > 0 ) {

		var macy = Macy({
		  container: '#masonry',
		  trueOrder: true,
		  margin: 16,
		  columns: 3,
          breakAt: {
            760: {
              margin: {
                x: 0,
                y: 56,
              },
              columns: 1
            }
          },
		  waitForImages: true
		});
		setTimeout(function(){
			$('.navigation-card').css('opacity', 1);
		}, 20);
	}

	if ( $('#masonry2').length > 0 ) {

		var macy = Macy({
		  container: '#masonry2',
		  trueOrder: true,
		  margin: 20,
		  columns: 3,
		  breakAt: {
		      520: 1,
		  },
		  waitForImages: true
		});
		setTimeout(function(){
			$('.navigation-card').css('opacity', 1);
		}, 20);
	}

    /* Image gallery */
    if ( $('#image-gallery').length > 0 ) {

		var macy = Macy({
		  container: '#image-gallery',
		  trueOrder: false,
		  margin: 16,
		  columns: 3,
          breakAt: {
            760: {
              columns: 2
            }
          },
		  waitForImages: true
		});

        setTimeout(function(){
			$('#image-gallery img').css('opacity', 1);
		}, 80);
	}
});
